import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// utils
import { LISTING_TYPE, Test } from '../../platformUtils';

// media
import verifyFilledStarIcon from '../../media/simple-mono-icons/verify-filled-star-icon.svg';


function PropertyCardTest(props: { property: Test; size: 'sm' | 'md'; }) {
    let listingTypeStr = 'Unlisted';

    switch(props.property.listingType) {
        case LISTING_TYPE.FOR_SALE:
            listingTypeStr = 'For Sale';
            break;
        case LISTING_TYPE.FOR_AUCTION_DUTCH:
            listingTypeStr = 'For Sale';
            break;
        case LISTING_TYPE.FOR_AUCTION_ENGLISH:
            listingTypeStr = 'For Auction';
            break;
        case LISTING_TYPE.FOR_RENT:
            listingTypeStr = 'For Rent';
            break;
        case LISTING_TYPE.UNLISTED:
            listingTypeStr = 'Unlisted';
            break;
        default:
            listingTypeStr = 'Unlisted';
            break;
    }

    return (
        <Link to={`/property/${props.property.tokenId}`}>
            <div role="link" className="relative bg-white rounded-2 p-2 shadow-lg transition-all cursor-pointer hover:scale-105 hover:shadow-2xl hover:z-10">
                <img className={`w-full rounded-2 mb-2 object-cover ${props.size == 'sm' ? 'aspect-half' : ''}`} src={props.property.imgUrls[0]} alt="" />
                <div className="p-3">
                    <div className="text-mid-grey italic text-sm mb-2 inline">{props.property.metaverse}<img className="inline ml-1" src={verifyFilledStarIcon} alt="Verified metaverse property" /></div>
                    <div className="font-bold mb-5">{props.property.name}</div>
                    <div className="text-mid-grey text-sm mb-1">{listingTypeStr}</div>
                    <div className="font-bold">{props.property.price}</div>
                </div>
            </div>
        </Link>
    );
}

export default PropertyCardTest;